import { render, staticRenderFns } from "./GPS.vue?vue&type=template&id=5ba285c7&"
import script from "./GPS.vue?vue&type=script&lang=ts&"
export * from "./GPS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports